const SETTINGS_PAGE_TABS = tt => ({
  LINKEDIN_SETTINGS: {
    key: "LINKEDIN_SETTINGS",
    title: tt("linkedin-settings"),
    urlKey: "linkedin-settings",
  },
  EMAIL_SETTINGS: { key: "EMAIL_SETTINGS", title: tt("email-settings"), urlKey: "email-settings" },
  BLACKLIST: { key: "BLACKLIST", title: tt("blacklist"), urlKey: "blacklist" },
})

const EMAIL_SETTINGS_TABS = tt => ({
  EMAIL_ACCOUNTS: {
    key: "EMAIL_ACCOUNTS",
    title: tt("email-accounts"),
    urlKey: "email-accounts",
  },
  EMAIL_PREFERENCES: {
    key: "EMAIL_PREFERENCES",
    title: tt("email-preferences"),
    urlKey: "email-preferences",
  },
})

const BLACKLIST_TABS = tt => ({
  YOUR_BLACKLIST: {
    key: "YOUR_BLACKLIST",
    title: tt("your-blacklist"),
    urlKey: "your-blacklist",
  },
  GLOBAL_BLACKLIST: {
    key: "GLOBAL_BLACKLIST",
    title: tt("global-blacklist"),
    urlKey: "global-blacklist",
  },
})

const settingsConstants = tt => ({
  SETTINGS_PAGE_TABS: SETTINGS_PAGE_TABS(tt),
  EMAIL_SETTINGS_TABS: EMAIL_SETTINGS_TABS(tt),
  BLACKLIST_TABS: BLACKLIST_TABS(tt),
})
export default settingsConstants

export { SETTINGS_PAGE_TABS, EMAIL_SETTINGS_TABS, BLACKLIST_TABS }
